/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-danger */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import routerLoader from '../../../i18n/router';
import tarjetaOro from '../../../assets/images/tarjeta-oro-bloque.png';
import { StorageHelper } from '../../../utils/StorageHelper';
import CalculadoraForm from '../../Tarjetas/commons/CalculadoraForm';
import SolictarTarjetaOroForm from '../forms/SolictarTarjetaOroForm';
import videoImg from '../../../assets/images/gold-club-video.png';
import { useAppStore } from '../../../store/AppContext';
import { useAuthStore } from '../../../store/AuthContext';
import { BackMappings } from '../../../utils/BackMappings';
import useSessionChecking from '../../../hooks/useSessionChecking';
import { GtmConstants } from '../../../utils/GtmConstants';
import { UtmManager } from '../../../utils/UtmManager';
import IconPlayVideo from '../../../Icons/IconPlayVideo';
import { WaEventsConstants } from '../wa-buttons/WaEventsConstants';
import { WaEventConponentFactory } from '../wa-buttons/WaEventConponentFactory';
import { GtmManager } from '../../../utils/GtmManager';

const SinTarjetaOroEroski: FC = () => {
  const { t } = useTranslation();
  const waEventConponentFactory = new WaEventConponentFactory(t);

  const dataApp = useAppStore();
  const dataUser = useAuthStore();
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.ORO);
  useSessionChecking(BackMappings.ORO, setGoOn, goOn);

  UtmManager.setAltaOroAttributesForUtmCampaign(UtmManager.getUtmCampaing());

  const openForm = StorageHelper.isOpenFormOro();
  const [formSolicitarVisible, setFormSolicitarVisible] = useState(openForm);
  const [load, setLoad] = useState<boolean>(true);
  const [showFormCalculadora, setShowFormCalculadora] = useState<boolean>(
    false,
  );
  const [reload, setReload] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const fromApp = dataUser.user.isApp === 'false' ? 'web' : 'app_club';

  const showVideo = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    // const video = document.getElementById('video_div') as HTMLDivElement;
    const imagen = document.getElementById('bloque-video') as HTMLDivElement;
    // video.classList.remove('hide');
    imagen.classList.add('hide');
    setShow(true);
  };

  const calculadoraOnclick = () => {
    setShowFormCalculadora(true);
    document.body.classList.add('fix');
  };

  useEffect(() => {
    if (reload) {
      const url = routerLoader.LoadRouterByPath('tarjeta-oro', dataApp.lang);
      window.location.href = url;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  useEffect(() => {
    if (openForm) {
      document.body.classList.add('fix');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emptyMethod = () => {
    return null;
  };

  if (goOn) {
    return (
      <div>
        {(() => {
          if (load) {
            return (
              <div>
                <section className="section header-tarjetas header-tarjetas__large tarjetas">
                  <div className="container-inner">
                    <div className="header-tarjetas__content">
                      <h1 className="header-tarjetas__title">
                        {t('tarjetas.hazte-oro.title')}
                      </h1>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: t('tarjetas.hazte-oro.subtitle'),
                        }}
                      />
                    </div>

                    <ul className="header-tarjetas__lista lista-oro u-text-white u-margin-top-giant-desktop u-margin-bottom">
                      <li>{t('tarjetas.hazte-oro.hero-line-one')}</li>
                      <li>{t('tarjetas.hazte-oro.hero-line-two')}</li>
                      <li>{t('tarjetas.hazte-oro.hero-line-three')}</li>
                    </ul>
                    <p className="u-text-white legal">
                      {t('tarjetas.hazte-oro.hero-min-text1')}
                      <br />
                      {t('tarjetas.hazte-oro.hero-min-text2')}
                      <a
                        href={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
                          'link.condiciones-oro',
                        )}?fromApp=${fromApp}`}
                        className="link link-negativo"
                      >
                        {t('tarjetas.tarjeta-socio.here')}
                      </a>
                    </p>
                    <div className="bloque-action__tarjeta bloque-action__tarjeta-oro ">
                      <p>{t('tarjetas.hazte-oro.request-it')}</p>
                      <div className="img img-tarjeta_small">
                        <img src={tarjetaOro} alt="Tarjeta Oro" />
                      </div>
                      <p className="bloque-action__title">
                        {t('tarjetas.hazte-oro.eroski-gold-card')}
                      </p>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        className="btn btn-default__oro solicitar-oro"
                        onClick={() => {
                          GtmManager.sendAComportamientoEvent({
                            event: GtmConstants.GOLD_CARD_ITERATION,
                            click_element: GtmConstants.MENU_ACTION_CTA,
                            category: GtmConstants.GOLD_CARD,
                            click_title: t(
                              'tarjetas.hazte-oro.eroski-gold-card',
                            ),
                            click_name: t(
                              'tarjetas.hazte-oro.request-gold-card',
                            ),
                            section: 'none',
                          });
                          setFormSolicitarVisible(true);
                          StorageHelper.setSolicitudOroOrigin(
                            BackMappings.TARJETA_MENU_ORO,
                          );
                          StorageHelper.revomeNoroLabel();
                          document.body.classList.add('fix');
                        }}
                      >
                        {t('tarjetas.hazte-oro.request-gold-card')}
                      </a>
                    </div>
                  </div>
                </section>

                <section className="o-section u-padding-top-hero u-padding-bottom-hero section--background-img tarjetas">
                  <div className="container-inner">
                    <div className="u-display-flex-desktop u-justify-content-space-between u-align-items-start">
                      <div className="tarjeta__content tarjeta-oro__content">
                        <h2 className="bloque-datos__title">
                          <span className="divider__square brand-gold-color" />
                          <span className="u-margin-right">
                            {t('tarjetas.hazte-oro.how-works')}
                          </span>
                        </h2>

                        <ul className="header-tarjetas__lista lista-oro">
                          <li
                            dangerouslySetInnerHTML={{
                              __html: t('tarjetas.hazte-oro.how-work-one'),
                            }}
                          />
                          <li
                            dangerouslySetInnerHTML={{
                              __html: t('tarjetas.hazte-oro.how-work-two'),
                            }}
                          />
                          <li
                            dangerouslySetInnerHTML={{
                              __html: t('tarjetas.hazte-oro.how-work-three'),
                            }}
                          />
                          <li
                            dangerouslySetInnerHTML={{
                              __html: t('tarjetas.hazte-oro.how-work-four'),
                            }}
                          />
                        </ul>
                      </div>

                      <div className="bloque-action__second">
                        <p className="bloque-action__title">
                          {t('tarjetas.hazte-oro.do-you-know')}
                        </p>
                        {(() => {
                          return waEventConponentFactory.getComponent(
                            WaEventsConstants.CALCULADORA,
                            calculadoraOnclick,
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                </section>

                <section className="o-section-large tarjetas">
                  {(() => {
                    if (!show) {
                      return (
                        <>
                          <div id="bloque-video" className="bloque-video">
                            <div className="img img-tarjeta_small">
                              <img
                                src={videoImg}
                                alt="Imagen de un video"
                                className="cursor-pointer"
                              />
                            </div>
                            <div className="bloque-video__icon">
                              <a href="" className="bloque-video__link" />
                              <div className="icon icon-especial icon--white">
                                <a
                                  href=""
                                  onClick={(e) => showVideo(e)}
                                  className="bloque-video__link"
                                >
                                  <IconPlayVideo />
                                </a>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    }
                    return (
                      <>
                        <div id="video_div" className="img img-tarjeta_small">
                          <iframe
                            className="iframe"
                            title="video"
                            src="https://www.youtube.com/embed/A60CtG9-_Fs?autoplay=1"
                            frameBorder="0"
                            allow="autoplay; fullscreen"
                          />
                        </div>
                      </>
                    );
                  })()}
                </section>
              </div>
            );
          }
          return false;
        })()}
        <SolictarTarjetaOroForm
          visible={formSolicitarVisible}
          setVisible={setFormSolicitarVisible}
          isDatosIncompletos={false}
          setReload={setReload}
          setErrorMDM={emptyMethod}
        />
        <CalculadoraForm
          visible={showFormCalculadora}
          setVisible={setShowFormCalculadora}
        />
      </div>
    );
  }
  return <></>;
};

export default SinTarjetaOroEroski;
